import React, { useState } from "react";
import TopTab from "../../../../components/TopTab/TopTab";
import { SubmitButton, TextComponent } from "../../../../components";
import styles from "./AdminOrderManagement.module.css";
import SubHeadingComponent from "../../../../components/SubHeadingComponent/SubHeadingComponent";
import AllOrder from "./AllOrder/AllOrder";
import Scheduled from "./Scheduled/Scheduled";
import InProgressOrder from "./InProgressOrder/InProgressOrder";
import CompletedOrder from "./CompletedOrder/CompletedOrder";
import PendingOrders from "./PendingOrders/PendingOrders";
import CancelledOrder from "./CancelledOrder/CancelledOrder";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import TopTabComponent from "../../../../components/TopTabComponent/TopTabComponent";

const AdminOrderManagement = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/CreateOrder");
  };
  const options = [
    { id: 1, name: "All Order" },
    { id: 2, name: "Scheduled" },
    { id: 3, name: "In Progress Order" },
    { id: 4, name: "Pending Orders" },
    { id: 5, name: "Completed Order" },
    { id: 6, name: "Cancelled Order" },
  ];

  const [focusedTab, setFocusedTab] = useState(options[0]);
 
  return (
    <div className={styles.mainCon}>
      <div className={styles.HeaderDiv}>
        <SubHeadingComponent
          text={t("Order Management")}
          className={styles.TextClass}
        />
        <SubmitButton
          onClick={handleNavigate}
          title={t("Create Order")}
          btnContainerClass={styles.Create_Order_btnContainer}
          textClass={styles.Create_Order_Text}
          btnClass={`${styles.Create_Order}`}
          primary
        />
      </div>
      <div className={styles.TopTabListStyle}>
        <TopTabComponent
          options={options}
          focused={focusedTab}
          setFocused={setFocusedTab}
          TopTabListStyle={styles.TopTabListStyle}
        />
      </div>

      {focusedTab?.name === options[0]?.name && <AllOrder />}
      {focusedTab?.name === options[1]?.name && <Scheduled />}
      {focusedTab?.name === options[2]?.name && <InProgressOrder />}
      {focusedTab?.name === options[3]?.name && <PendingOrders />}
      {focusedTab?.name === options[4]?.name && <CompletedOrder />}
      {focusedTab?.name === options[5]?.name && <CancelledOrder />}
    </div>
  );
};

export default AdminOrderManagement;
